const castThunk = (a) => typeof a === "function" ? a : () => a;
export {
  castThunk
};
//# sourceMappingURL=castThunk.js.map
